module.exports = __webpack_public_path__ + "static/media/default.7ab85000.svg";